import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

const styles = {
  button: {
    padding: '1px',
    pointerEvents: 'none'
  },
  iconColor: {
    color: 'gray'
  }
};

const enhance = compose();

const button = enhance(({ classes }) => {
  return (
    <Button className={classes.button} tabIndex="-1">
      <RemoveCircleIcon className={classes.iconColor} />
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
